import React from 'react'

export const ColoredLine = ( { color } ) => (
    <hr
        style={ {
            color: color,
            height: 23,
        } }
    />
)